module.exports = __webpack_public_path__ + "img/robot.34f75134.svg";